import getConfig from 'next/config';

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

export const isServerRequest = () => typeof window === 'undefined';

export const getBaseDomain = () =>
  isServerRequest()
    ? `${serverRuntimeConfig?.protocol}://${serverRuntimeConfig?.baseApiDomain}`
    : `${publicRuntimeConfig?.protocol}://${publicRuntimeConfig?.baseDomain}`;

export const csrfRoute = `${getBaseDomain()}/accounts/api/v1/users/csrf`;

export const auctionsRoute = `${getBaseDomain()}/buyer/api/v1/auctions`;
export const lotsRoute = `${getBaseDomain()}/buyer/api/v1/lots`;
export const lotPricesRoute = `${getBaseDomain()}/buyer/api/v3/bidding/lots`;
export const menuCategoriesRoute = `${getBaseDomain()}/buyer/api/v1/menu`;
export const categoriesRoute = `${getBaseDomain()}/buyer/api/v1/categories`;
export const expertRoute = (expertId: number) =>
  `${getBaseDomain()}/buyer/api/v1/experts/${expertId}`;
export const collectionInfoRoute = (collectionId: number) =>
  `${getBaseDomain()}/buyer/api/v1/collections/${collectionId}`;

export const userRoutes = {
  me: () => `${getBaseDomain()}/buyer/api/v1/users/me`,
  favorites: () => `${getBaseDomain()}/buyer/api/v1/users/me/favorites`,
  interestsLots: () =>
    `${getBaseDomain()}/buyer/api/v1/users/me/interests/lots`,
};
